import { createFinanceStaffRequestPage } from './FinanceStaffRequestPortal';

const FinanceLibrarians = createFinanceStaffRequestPage({
  apiBase: '/finance/librarians',
  addType: 'librarian_add',
  exitType: 'librarian_exit',
  reactivateType: 'librarian_reactivate',
  targetRole: 'librarian',
  entityLabel: 'Librarian',
  entityLabelPlural: 'Librarians',
  accent: '#f59e0b',
  designationOptions: ['Librarian', 'Assistant Librarian', 'Library Assistant'],
});

export default FinanceLibrarians;
